import {Principal} from 'app/core/auth/principal.service';
import {NgModule, LOCALE_ID, ModuleWithProviders, ErrorHandler} from '@angular/core';
import {DatePipe, registerLocaleData} from '@angular/common';
import {Title} from '@angular/platform-browser';
import locale from '@angular/common/locales/en';
import {LoginService} from 'app/core/login/login.service';
import {AccountService} from 'app/core/auth/account.service';
import {StateStorageService} from 'app/core/auth/state-storage.service';
import {CSRFService} from 'app/core/auth/csrf.service';
import {AuthServerProvider} from 'app/core/auth/auth-jwt.service';
import {UserService} from 'app/core/user/user.service';
import {UserRouteAccessService} from 'app/core/auth/user-route-access-service';
import {CustomerRouteAccessService} from 'app/core/auth/customer-route-access-service';
import {NGXS_PLUGINS} from '@ngxs/store';
import {logoutPlugin} from 'app/blocks/store/actions/logout-reducer';
import {ErrorHandlerService} from 'app/core/error/error-handler.service';

@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: []
})
export class DiCoreModule {
    constructor() {
        registerLocaleData(locale);
    }

    static forRoot(): ModuleWithProviders<DiCoreModule> {
        return {
            ngModule: DiCoreModule,
            providers: [
                LoginService,
                AccountService,
                StateStorageService,
                Principal,
                CSRFService,
                AuthServerProvider,
                UserService,
                UserRouteAccessService,
                CustomerRouteAccessService,
                Title,
                {
                    provide: LOCALE_ID,
                    useValue: 'en'
                },
                {
                    provide: NGXS_PLUGINS,
                    useValue: logoutPlugin,
                    multi: true
                },
                {
                    provide: ErrorHandler,
                    useClass: ErrorHandlerService
                },
                DatePipe
            ]
        };
    }
}
